import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetCall } from '../utility/site-apis'

const initialState = {
    isFetching: false,
    error: null,
    orders: [],
    orderDetails: {},
    winnerDetails: [],
    participationHistory: [],
    partDetails: null,
    testimonials: [],
    diduknows: [],
    diduknow: null,
    terms: null,
    privacy: null,
    faqs: [],
}

export const getOrders = createAsyncThunk(
    'order/getOrders',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/order/list`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getSingleOrders = createAsyncThunk(
    'order/getSingleOrders',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/order/${params.id}`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getSingleWinners = createAsyncThunk(
    'order/getSingleWinners',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/contestants/leaderboard`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getParticipationHistory = createAsyncThunk(
    'order/getParticipationHistory',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/order/participationHistory`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getTestimonials = createAsyncThunk(
    'order/getTestimonials',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/testimonials/public-list`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getDiduknows = createAsyncThunk(
    'order/getDiduknows',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/diduknows/public-list`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)

export const getTerms = createAsyncThunk(
    'order/getTerms',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/pages/terms_conditions`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getPrivacy = createAsyncThunk(
    'order/getPrivacy',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/pages/privacy_policy`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)
export const getFaqs = createAsyncThunk(
    'order/getFaqs',
    async (params, { rejectWithValue }) => {
        const response = await apiGetCall(`/pages/faqs`, params)
        if (response.data.status === 'error') {
            return rejectWithValue(response.data)
        }
        return response.data
    }
)

export const counterSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setPartDetails: (state, action) => {
            state.partDetails = action.payload
        },
        setDiduknow: (state, action) => {
            state.diduknow = action.payload
        },
    },
    extraReducers: {
        [getOrders.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getOrders.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getOrders.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.orders = action.payload.data.data
        },
        [getSingleOrders.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getSingleOrders.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getSingleOrders.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.orderDetails = action.payload.data
        },
        [getSingleWinners.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getSingleWinners.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getSingleWinners.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.winnerDetails = action.payload.data
        },

        [getParticipationHistory.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getParticipationHistory.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getParticipationHistory.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.participationHistory = action.payload.data
        },
        // getTestimonials
        [getTestimonials.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getTestimonials.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getTestimonials.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.testimonials = action.payload.data
        },
        // getDiduknows
        [getDiduknows.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getDiduknows.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getDiduknows.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.diduknows = action.payload.data
        },
        // getTerms
        [getTerms.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getTerms.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getTerms.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.terms = action.payload.data
        },
        // getPrivacy
        [getPrivacy.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getPrivacy.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getPrivacy.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.privacy = action.payload.data
        },
        // getFaqs
        [getFaqs.pending]: (state, action) => {
            state.isFetching = true
            state.error = null
        },
        [getFaqs.rejected]: (state, action) => {
            state.isFetching = false
            state.error = action?.payload?.message
        },
        [getFaqs.fulfilled]: (state, action) => {
            state.isFetching = false
            state.error = null
            state.faqs = action.payload.data
        },

    }

})
export const { setPartDetails, setDiduknow } = counterSlice.actions

export default counterSlice.reducer